//#region Util Imports

import * as _ from 'underscore'
import * as $ from 'jquery'

//#endregion

//#region IMR Imports

import { IIMRPopup, IMRPopupOptions } from '@imr/controls.angularjs/components/overlay/popup'

//#endregion

import { LocalizationHelper } from '../../../helpers'

import { IMRBaseControlController } from '../base'

import { IMRConfirmationPopupOptions, IIMRConfirmationPopup, IMRConfirmationPopupShowOptions, IMRConfirmationPopupResult } from './confirmation-popup.interfaces'
import { IMRComponentInitializedArgs } from '@imr/controls.angularjs/components/base'


export class IMRConfirmationPopupController
    extends
    IMRBaseControlController<IIMRConfirmationPopup, IMRConfirmationPopupOptions>
    implements
    IIMRConfirmationPopup {

    //#region Members


    private currentShowDeferred: JQueryDeferred<IMRConfirmationPopupResult>
    private currentShowOptions: IMRConfirmationPopupShowOptions
    private currentResult: IMRConfirmationPopupResult

    //#endregion


    //#region Properties

    public get content(): string {
        if (this.currentShowOptions != null && this.currentShowOptions.content != null) {
            return this.currentShowOptions.content
        }

        return this.options.content
    }

    //#endregion


    //#region Component

    protected initialize(options: IMRConfirmationPopupOptions): JQueryPromise<void> {
        return this.initializePopup()
    }

    //#endregion


    //#region Events

    private onConfirmed(): void {
        if (this.currentShowOptions != null && _.isFunction(this.currentShowOptions.onConfirmed)) {
            this.currentShowOptions.onConfirmed()
        }
        else if (this.options != null && _.isFunction(this.options.onConfirmed)) {
            this.options.onConfirmed()
        }
    }

    private onDeclined(): void {
        if (this.currentShowOptions != null && _.isFunction(this.currentShowOptions.onDeclined)) {
            this.currentShowOptions.onDeclined()
        }
        else if (this.options != null && _.isFunction(this.options.onDeclined)) {
            this.options.onDeclined()
        }
    }

    private onCancelled(): void {
        if (this.currentShowOptions != null && _.isFunction(this.currentShowOptions.onCancelled)) {
            this.currentShowOptions.onCancelled()
        }
        else if (this.options != null && _.isFunction(this.options.onCancelled)) {
            this.options.onCancelled()
        }
    }

    //#endregion


    //#region IIMRConfirmationPopup Implementation

    private _popup: IIMRPopup
    public get popup(): IIMRPopup {
        return this._popup
    }

    public show(showOptions: IMRConfirmationPopupShowOptions = null): JQueryPromise<IMRConfirmationPopupResult> {
        if (showOptions != null) {
            this.currentShowOptions = showOptions

            if (showOptions.title != null) {
                this.popup.getInnerPopup().option('title', showOptions.title)
            }
        }

        this.popup.show()
        this.currentShowDeferred = $.Deferred<IMRConfirmationPopupResult>()

        return this.currentShowDeferred.promise()
    }

    //#endregion


    //#region Result

    private createResult(): IMRConfirmationPopupResult {
        return {
            confirmed: false,
            declined: false,
            canceled: false,
        }
    }

    private onResultCancelled(): void {
        const result: IMRConfirmationPopupResult = this.createResult()

        result.canceled = true

        this.onCancelled()
        this.resolveResult(result)
    }

    private onResultConfirmed(): void {
        const result: IMRConfirmationPopupResult = this.createResult()

        result.confirmed = true

        this.onConfirmed()
        this.resolveResult(result)
    }

    private onResultDeclined(): void {
        const result: IMRConfirmationPopupResult = this.createResult()

        result.declined = true

        this.onDeclined()
        this.resolveResult(result)
    }

    private resolveResult(result: IMRConfirmationPopupResult): void {
        this.currentResult = result
        this.popup.getInnerPopup().option('title', this.options.title)
        this.popup.hide()
    }

    //#endregion


    //#region Popup

    public popupOptions: IMRPopupOptions

    private initializePopup(): JQueryPromise<any> {
        this.popupOptions = {
            bottomToolbarOptions: {
                innerOptions: {
                    items: [{
                        location: 'center',
                        widget: 'dxButton',
                        options: {
                            text: LocalizationHelper.getLocalizedText(LocalizationHelper.Text.Yes),

                            onClick: () => {
                                this.onResultConfirmed()
                            }
                        }
                    }, {
                        location: 'center',
                        widget: 'dxButton',
                        options: {
                            text: LocalizationHelper.getLocalizedText(LocalizationHelper.Text.No),

                            onClick: () => {
                                this.onResultDeclined()
                            }
                        }
                    }]
                }
            },

            innerOptions: {
                height: 200,
                maxWidth: 400,
                showCloseButton: false,
                title: this.options.title,

                onHidden: () => {
                    this.onPopupHidden()
                }
            },

            onInitialized: (e: IMRComponentInitializedArgs<IIMRPopup>) => {
                this.onPopupInitialized(e.component)
            }
        }

        return super.waitForOnInitialized(this.popupOptions)
    }

    private onPopupHidden(): void {
        if (!this.currentResult) {
            this.onResultCancelled()
        }

        this.currentShowOptions = null

        if (this.currentShowDeferred != null) {
            this.currentShowDeferred.resolve(this.currentResult)
        }

        this.currentResult = null
    }

    private onPopupInitialized(component: IIMRPopup): void {
        this._popup = component
    }

    //#endregion
}
